import { Property } from '../../core/models/property.model';

function normalizeText(value: unknown): string {
    return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ');
}

export function isGroundFloorValue(floor: string | null | undefined): boolean {
    if (!floor) return false;
    const v = normalizeText(floor);
    if (!v) return false;
    return v === '0' || v === '0 0' || v.includes('ground') || v === 'gf' || v.startsWith('gf ');
}

export function propertyFeatureLabels(property: Property | null | undefined): string[] {
    const labels = new Set<string>();

    for (const tag of property?.tags || []) {
        const value = String(tag || '').trim();
        if (value) labels.add(value);
    }

    for (const feature of property?.features || []) {
        const value = String(feature?.name || '').trim();
        if (value) labels.add(value);
    }

    if ((property?.gardenArea || 0) > 0) labels.add('Garden');
    if ((property?.terraceArea || 0) > 0) labels.add('Terrace');
    if ((property?.balconyArea || 0) > 0) labels.add('Balcony');
    if (isGroundFloorValue(property?.floor)) labels.add('Ground Floor');

    return Array.from(labels);
}

export function propertyFeatureSearchTerms(property: Property | null | undefined): string[] {
    const terms = new Set(propertyFeatureLabels(property));
    for (const feature of property?.features || []) {
        const value = String(feature?.value || '').trim();
        if (value) terms.add(value);
    }
    return Array.from(terms);
}

function labelsContain(labels: string[], expected: string): boolean {
    const target = normalizeText(expected);
    return labels.some((label) => {
        const hay = normalizeText(label);
        return hay === target || hay.includes(target);
    });
}

export function propertyHasGarden(property: Property | null | undefined): boolean {
    const labels = propertyFeatureLabels(property);
    return (property?.gardenArea || 0) > 0 || labelsContain(labels, 'garden');
}

export function propertyHasTerrace(property: Property | null | undefined): boolean {
    const labels = propertyFeatureLabels(property);
    return (property?.terraceArea || 0) > 0 || labelsContain(labels, 'terrace');
}

export function propertyHasRoof(property: Property | null | undefined): boolean {
    return labelsContain(propertyFeatureLabels(property), 'roof');
}

export function propertyOutdoorFeatureSummary(property: Property | null | undefined): string {
    const items: string[] = [];
    if (propertyHasGarden(property)) items.push('Garden');
    if (propertyHasRoof(property)) items.push('Roof');
    if (propertyHasTerrace(property)) items.push('Terrace');
    return items.length ? Array.from(new Set(items)).join(' / ') : '—';
}
